// src/redux/slices/menuItemsSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MenuItem {
  pk_id: string;
  restaurant_id: string;
  sku_id: string;
  name: string;
  category: string;
  description: string;
  price: {dining: number; online: number} | string; // Support both object and string
  large_price: string;
  indining_price: string;
  indining_large_price: string;
  image: string;
  is_enabled: boolean;
  is_item_verified: boolean;
  product_description: string;
  level1_category: string;
  level2_category: string;
  ingredients: string[];
  allergens: string[];
  food_type: string;
  is_vegan: string;
  modifiers_list: any[];
  party_orders: any[];
  builder_type?: string;
  inventoryStatus?: boolean; // Track inventory status for UI
  [key: string]: any;
}

interface MenuItemsState {
  items: MenuItem[];
  loading: boolean;
  error: string | null;
  selectedCategory: string | null;
}

const initialState: MenuItemsState = {
  items: [],
  loading: false,
  error: null,
  selectedCategory: null,
};

export const menuItemsSlice = createSlice({
  name: 'menuItems',
  initialState,
  reducers: {
    // Fetch menu items actions
    fetchMenuItemsRequest: state => {
      state.loading = true;
      state.error = null;
    },
    fetchMenuItemsSuccess: (state, action: PayloadAction<MenuItem[]>) => {
      state.loading = false;
      state.items = action.payload;
      state.error = null;
    },
    fetchMenuItemsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.items = [];
    },

    // Category selection
    setSelectedCategory: (state, action: PayloadAction<string | null>) => {
      state.selectedCategory = action.payload;
    },

    // Clear menu items
    clearMenuItems: state => {
      state.items = [];
      state.error = null;
      state.loading = false;
      state.selectedCategory = null;
    },
  },
});

export const {
  fetchMenuItemsRequest,
  fetchMenuItemsSuccess,
  fetchMenuItemsFailure,
  setSelectedCategory,
  clearMenuItems,
} = menuItemsSlice.actions;

export default menuItemsSlice.reducer;
